import React from "react";
import { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Checkbox,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./Template.scss";
import { useNavigate } from "react-router-dom";
import HouseIcon from "@mui/icons-material/House";
import { Switch } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Save as SaveIcon, Add as AddIcon } from "@mui/icons-material";
import ListItemText from "@mui/material/ListItemText";
import { getReportFilterData } from "./../../Utils/actions/yh";
import { useDispatch, useSelector } from "react-redux";
import { insertTemplate } from "../../Utils/actions";
import { getApiUserRoles } from "../../Utils/actions";
import { loadingOn } from "../../Utils/utils";
import { buttonStyle } from "../../Style/ManualStyle";

const Template = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { reportFilterData } = useSelector((state) => state.yh);

  const [newUom, setNewUom] = useState("");
  const [newDataType, setNewDataType] = useState("");
  const [newRuleName, setnewRuleName] = useState("");
  const [activeSwitch, setActiveSwitch] = useState(true);
  const [uomList, setUomList] = useState([]);
  const [dataTypeList, setDataTypeList] = useState([]);
  const [show, setShow] = useState(false);
  const [ruleName, setRuleName] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [names, setNames] = useState([]);
  const [templateValues, setTemplateValues] = useState({
    log: "",
    rig: "",
    well: "",
    bunit: "",
    UidLog: "",
    UidWell: "",
    logType: "",
    slideBy: 0,
    nameWell: "",
    wellbore: "",
    isRunning: true,
    UidWellbore: "",
    dataProvider: "",
    nameWellbore: "",
    syncEndPoint: {
      isSecure: "",
      port: "",
      host: "",
      clientId: "",
      apiKey: "",
      type: "",
    },
    templateName: "",
    windowLength: 0,
    sourceEndPoint: {
      isSecure: "",
      port: "",
      host: "",
      clientId: "",
      apiKey: "",
      type: "",
    },
  });
  const [templateRuleValues, setTemplateRuleValues] = useState({
    rules: [],
  });

  const wellBores = true;

  useEffect(() => {
    dispatch(loadingOn());
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
    dispatch(getReportFilterData(wellBores));
  }, []);

  const handleChange = (event) => {
    const { id, value, name } = event.target;

    const isObjectField = name && name.includes(".");
    if (isObjectField) {
      let [endpoint, field] = name.split(".");

      setTemplateValues((prevState) => ({
        ...prevState,
        [endpoint]: {
          ...prevState[endpoint],
          [field]: value,
        },
      }));
    } else {
      setTemplateValues((prevState) => ({
        ...prevState,
        [name]: value,
        nameWell: name === "well" ? value : prevState.nameWell,
        nameWellbore: name === "wellbore" ? value : prevState.nameWellbore,
      }));
    }
  };

  const handleRuleChange = (event, ruleIndex, aspectIndex, propertyName) => {
    const { value, checked, name } = event.target;

    setTemplateRuleValues((prevState) => {
      const updatedRules = [...prevState.rules];
      if (updatedRules[ruleIndex]) {
        // Check if the rule exists
        const updatedAspects = [...updatedRules[ruleIndex].aspects];
        if (updatedAspects[aspectIndex]) {
          // Check if the aspect exists
          const updatedAspect = { ...updatedAspects[aspectIndex] };

          // Update the aspect property based on the propertyName
          if (name === "status") {
            updatedAspect[propertyName] = checked ? "enable" : "disable";
          } else {
            updatedAspect[propertyName] = value;
          }

          updatedAspects[aspectIndex] = updatedAspect;
          updatedRules[ruleIndex] = {
            ...updatedRules[ruleIndex],
            aspects: updatedAspects,
          };

          return { ...prevState, rules: updatedRules };
        }
      }
      return prevState; // Return the prevState without any changes
    });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeName = (event) => {
    const { value } = event.target;
    const selectedNames = typeof value === "string" ? value.split(",") : value;
    setRuleName(selectedNames);
  };

  const handleuomdpChange = (event, ruleIndex) => {
    const { name, value } = event.target;

    setTemplateRuleValues((prevState) => {
      const updatedRules = [...prevState.rules];
      if (updatedRules[ruleIndex]) {
        updatedRules[ruleIndex][name] = value; // Set the value for the respective property (uom or datatype)
      }
      return { ...prevState, rules: updatedRules };
    });
  };

  const handleModelChange = (event) => {
    const { name, value } = event.target;
    if (name === "uom") {
      setNewUom(value);
    } else if (name === "datatype") {
      setNewDataType(value);
    } else if (name === "ruleName") {
      setnewRuleName(value);
    }
  };

  const handleSaveModel = () => {
    setNames((prevNames) => [...prevNames, newRuleName]);
    setUomList((prevNames) => [...prevNames, newUom]);
    setDataTypeList((prevNames) => [...prevNames, newDataType]);
    handleClose();
  };

  const updateTemplateRuleValues = (selectedNames) => {
    // Create or update the rules array
    const updatedRules = selectedNames.map((name, index) => {
      const existingRuleIndex = templateRuleValues.rules.findIndex(
        (rule) => rule.name === name
      );
      if (existingRuleIndex !== -1) {
        // If the rule already exists, return it
        return templateRuleValues.rules[existingRuleIndex];
      } else {
        const newRule = {
          uom: "",
          datatype: "",
          name: name,
          aspects: [
            {
              name: "frequency",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "precision",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "dataGap",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "dataCount",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "latency",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "minValue",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "maxValue",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
            {
              name: "staleValue",
              status: "enable",
              aspectType: "Number",
              expectedValue: "",
              deltaValue: 0,
              weightage: "",
              ttThreshold: "",
            },
          ],
        };

        return newRule;
      }
    });

    // Update the state with the new rules
    setTemplateRuleValues((prevState) => ({
      ...prevState,
      rules: updatedRules,
    }));
  };

  useEffect(() => {
    updateTemplateRuleValues(ruleName);
  }, [ruleName]);

  const handleSaveData = () => {
    // Check for errors before saving data
    let hasEmptyField = false;

    for (const field in templateValues.sourceEndPoint) {
      // Check if any field is empty
      if (templateValues.sourceEndPoint[field] === "") {
        hasEmptyField = true;
        break; // Exit function if any field is empty
      }
    }

    for (const field in templateValues.syncEndPoint) {
      // Check if any field is empty
      if (templateValues.syncEndPoint[field] === "") {
        hasEmptyField = true;
        break; // Exit function if any field is empty
      }
    }

    if (!hasEmptyField) {
      const additionalFields = [
        "bunit",
        "dataProvider",
        "rig",
        "well",
        "wellbore",
        "log",
      ];
      for (const field of additionalFields) {
        // Check if any additional field is empty
        if (templateValues[field] === "") {
          hasEmptyField = true;
          break; // Exit function if any field is empty
        }
      }
    }

    if (!hasEmptyField) {
      const combinedData = {
        ...templateValues,
        ...templateRuleValues,
      };

      dispatch(insertTemplate(combinedData));

      // if (formSubmitted) {
      navigate("/dashboard");
      // }
    }

    // Set formSubmitted to true after checking for empty fields
    setFormSubmitted(true);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = function (event) {
        const fileData = event.target.result;

        try {
          // Parse the file data as JSON
          const jsonData = JSON.parse(fileData);

          // Update the templateValues state with the values from the file
          setTemplateValues((prevTemplateValues) => {
            const updatedTemplateValues = { ...prevTemplateValues };
            Object.keys(jsonData).forEach((key) => {
              if (updatedTemplateValues.hasOwnProperty(key)) {
                updatedTemplateValues[key] = jsonData[key];
              }
            });
            setActiveSwitch(jsonData.isRunning);
            return updatedTemplateValues;
          });

          // Update the templateRuleValues state with the values from the file
          setTemplateRuleValues((prevTemplateValues) => {
            const updatedTemplateValues = { ...prevTemplateValues };
            Object.keys(jsonData).forEach((key) => {
              if (updatedTemplateValues.hasOwnProperty(key)) {
                updatedTemplateValues[key] = jsonData[key];
              }
            });

            // Extract names from updatedTemplateValues.rules
            const ruleNames = updatedTemplateValues.rules.map(
              (rule) => rule.name
            );

            // Update the ruleName state with the extracted names
            setRuleName(ruleNames);

            // Add only new rule names that are not already in the names list
            const newNames = ruleNames.filter((name) => !names.includes(name));
            setNames((prevNames) => [...prevNames, ...newNames]);

            return updatedTemplateValues;
          });
        } catch (error) {
          console.error("Error parsing file data:", error);
        }
      };

      reader.readAsText(file);
    }
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#1e1e1e",
          height: "89vh",
          padding: "15px",
          overflow: "hidden",
          border: "none",
        }}
      >
        <div
          style={{
            backgroundColor: "#242424",
            flexWrap: "wrap",
            overflowY: "auto",
            overflowX: "hidden",
            borderRadius: "5px",
            padding: "0px 15px",
            height: "100%",
          }}
        >
          <div style={{ marginTop: "25px", padding: "0px 15px" }}>
            <div style={{ position: "relative" }}>
              <input
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}
                id="uploadInput"
              />
              <label htmlFor="uploadInput">
                <Tooltip title="Upload">
                  <Button
                    variant="contained"
                    component="span"
                    style={{
                      // backgroundColor: "#c7c7c7",
                      // color: "white",
                      position: "absolute",
                      right: 70,
                      top: 0,
                      padding: "5px 10px",
                      background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
                      border: "1px solid #3a3a3a",
                      color: "#ffffff",
                      /* font-weight: 600; */
                      fontSize: "5px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
                      transition: "background 0.3s ease, transform 0.2s ease",
                    }}
                  >
                    Upload
                  </Button>
                </Tooltip>
              </label>

              <Tooltip title="Dashboard">
                <Button
                  size={"small"}
                  startIcon={<HouseIcon />}
                  onClick={() => {
                    navigate("/dashboard");
                  }}
                  style={{
                    // backgroundColor: "#fff",
                    color: "#c7c7c7",
                    position: "absolute",
                    right: 0,
                    top: 0,
                  }}
                />
              </Tooltip>

              <>
                <div>
                  <p className="nameHeading" style={{ color: "#c7c7c7" }}>
                    Source End Point
                  </p>

                  <TextField
                    id="sourceEndPoint.isSecure"
                    select
                    className="mr-2 mb-2"
                    label="Is Secure"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    name="sourceEndPoint.isSecure"
                    style={{ width: "203px" }}
                    value={templateValues.sourceEndPoint.isSecure}
                    onChange={handleChange}
                    required
                    error={
                      formSubmitted &&
                      templateValues.sourceEndPoint.isSecure === ""
                    }
                    helperText={
                      formSubmitted &&
                      templateValues.sourceEndPoint.isSecure === ""
                        ? "isSecure is required"
                        : ""
                    }
                  >
                    <MenuItem value="true">True</MenuItem>
                    <MenuItem value="false">False</MenuItem>
                  </TextField>

                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="sourceEndPoint.port"
                    name="sourceEndPoint.port"
                    size="small"
                    label="Port"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.sourceEndPoint.port}
                    error={
                      formSubmitted && templateValues.sourceEndPoint.port === ""
                    }
                    helperText={
                      formSubmitted && templateValues.sourceEndPoint.port === ""
                        ? "Port is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="sourceEndPoint.host"
                    name="sourceEndPoint.host"
                    size="small"
                    label="Host"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.sourceEndPoint.host}
                    error={
                      formSubmitted && templateValues.sourceEndPoint.host === ""
                    }
                    helperText={
                      formSubmitted && templateValues.sourceEndPoint.host === ""
                        ? "Host is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="sourceEndPoint.clientId"
                    name="sourceEndPoint.clientId"
                    size="small"
                    label="Client Id"
                    variant="outlined"
                    required={true}
                    onChange={handleChange}
                    value={templateValues.sourceEndPoint.clientId}
                    error={
                      formSubmitted &&
                      templateValues.sourceEndPoint.clientId === ""
                    }
                    helperText={
                      formSubmitted &&
                      templateValues.sourceEndPoint.clientId === ""
                        ? "ClientId is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="sourceEndPoint.apiKey"
                    name="sourceEndPoint.apiKey"
                    size="small"
                    label="API Key"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.sourceEndPoint.apiKey}
                    error={
                      formSubmitted &&
                      templateValues.sourceEndPoint.apiKey === ""
                    }
                    helperText={
                      formSubmitted &&
                      templateValues.sourceEndPoint.apiKey === ""
                        ? "ApiKey is required"
                        : ""
                    }
                  />
                  <TextField
                    id="sourceEndPoint.type"
                    name="sourceEndPoint.type"
                    select
                    label="Type"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    value={templateValues.sourceEndPoint.type}
                    onChange={handleChange}
                    style={{ width: "203px" }}
                    className="mr-2 mb-2"
                    required
                    error={
                      formSubmitted && templateValues.sourceEndPoint.type === ""
                    }
                    helperText={
                      formSubmitted && templateValues.sourceEndPoint.type === ""
                        ? "Type is required"
                        : ""
                    }
                  >
                    <MenuItem value="YH">YH</MenuItem>
                    <MenuItem value="WITSML">WITSML</MenuItem>
                  </TextField>
                </div>

                <div className="mt-4 ">
                  <p className="nameHeading" style={{ color: "#c7c7c7" }}>
                    Sync End Point
                  </p>
                  <TextField
                    id="syncEndPoint.isSecure"
                    select
                    label="Is Secure"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    name="syncEndPoint.isSecure"
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    value={templateValues.syncEndPoint.isSecure}
                    onChange={handleChange}
                    required
                    error={
                      formSubmitted &&
                      templateValues.syncEndPoint.isSecure === ""
                    }
                    helperText={
                      formSubmitted &&
                      templateValues.syncEndPoint.isSecure === ""
                        ? "isSecure is required"
                        : ""
                    }
                  >
                    <MenuItem value="true">True</MenuItem>
                    <MenuItem value="false">False</MenuItem>
                  </TextField>
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="syncEndPoint.port"
                    name="syncEndPoint.port"
                    size="small"
                    label="Port"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.syncEndPoint.port}
                    error={
                      formSubmitted && templateValues.syncEndPoint.port === ""
                    }
                    helperText={
                      formSubmitted && templateValues.syncEndPoint.port === ""
                        ? "Port is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="syncEndPoint.host"
                    name="syncEndPoint.host"
                    size="small"
                    label="Host"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.syncEndPoint.host}
                    error={
                      formSubmitted && templateValues.syncEndPoint.host === ""
                    }
                    helperText={
                      formSubmitted && templateValues.syncEndPoint.host === ""
                        ? "Host is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="syncEndPoint.clientId"
                    name="syncEndPoint.clientId"
                    size="small"
                    label="Client Id"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.syncEndPoint.clientId}
                    error={
                      formSubmitted &&
                      templateValues.syncEndPoint.clientId === ""
                    }
                    helperText={
                      formSubmitted &&
                      templateValues.syncEndPoint.clientId === ""
                        ? "ClientId is required"
                        : ""
                    }
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="syncEndPoint.apiKey"
                    name="syncEndPoint.apiKey"
                    size="small"
                    label="API Key"
                    variant="outlined"
                    onChange={handleChange}
                    required
                    value={templateValues.syncEndPoint.apiKey}
                    error={
                      formSubmitted && templateValues.syncEndPoint.apiKey === ""
                    }
                    helperText={
                      formSubmitted && templateValues.syncEndPoint.apiKey === ""
                        ? "ApiKey is required"
                        : ""
                    }
                  />
                  <TextField
                    id="syncEndPoint.type"
                    name="syncEndPoint.type"
                    select
                    label="Type"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    value={templateValues.syncEndPoint.type}
                    onChange={handleChange}
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    required
                    error={
                      formSubmitted && templateValues.syncEndPoint.type === ""
                    }
                    helperText={
                      formSubmitted && templateValues.syncEndPoint.type === ""
                        ? "Type is required"
                        : ""
                    }
                  >
                    <MenuItem value="YH">YH</MenuItem>
                  </TextField>
                </div>

                <hr style={{ backgroundColor: "#c7c7c7" }} className="mt-4 " />

                <div className="mt-4 ">
                  <div className="d-flex justify-content-between">
                    <p className="nameHeading" style={{ color: "#c7c7c7" }}>
                      Configuration
                    </p>

                    <Stack direction="row" alignItems="center" className="mr-4">
                      <Typography style={{ color: "#c7c7c7" }}>
                        In Active
                      </Typography>
                      <Switch
                        checked={activeSwitch === true}
                        onChange={() => {
                          const newValue = !activeSwitch;
                          setActiveSwitch(newValue);
                          handleChange({
                            target: {
                              name: "isRunning",
                              value: newValue,
                            },
                          });
                        }}
                      />
                      <Typography style={{ color: "#c7c7c7" }}>
                        Active
                      </Typography>
                    </Stack>
                  </div>
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="templateName"
                    name="templateName"
                    size="small"
                    label="Template Name"
                    variant="outlined"
                    value={templateValues.templateName}
                    onChange={handleChange}
                  />

                  <TextField
                    className="mr-2 mb-2"
                    id="bunit"
                    select
                    label="Business Unit"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    name="bunit"
                    style={{ width: "203px" }}
                    value={templateValues.bunit}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.bunit === ""}
                    helperText={
                      formSubmitted && templateValues.bunit === ""
                        ? "Business Unit is required"
                        : ""
                    }
                  >
                    {reportFilterData?.data.businessUnit.map((bunit) => (
                      <MenuItem key={bunit.name} value={bunit.name}>
                        {bunit.name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    className="mr-2 mb-2"
                    id="dataProvider"
                    select
                    label="Data Provider"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    name="dataProvider"
                    style={{ width: "203px" }}
                    value={templateValues.dataProvider}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.dataProvider === ""}
                    helperText={
                      formSubmitted && templateValues.dataProvider === ""
                        ? "Data Provider is required"
                        : ""
                    }
                  >
                    {(
                      reportFilterData?.data.businessUnit.find(
                        (unit) => unit.name === templateValues.bunit
                      )?.dataProviders || []
                    ).map((dataProvider) => (
                      <MenuItem
                        key={dataProvider.name}
                        value={dataProvider.name}
                      >
                        {dataProvider.name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    className="mr-2 mb-2"
                    id="rig"
                    select
                    label="Rig"
                    variant="outlined"
                    size="small"
                    name="rig"
                    style={{ width: "203px" }}
                    value={templateValues.rig}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.rig === ""}
                    helperText={
                      formSubmitted && templateValues.rig === ""
                        ? "Rig is required"
                        : ""
                    }
                  >
                    {(
                      reportFilterData?.data.businessUnit
                        .find((unit) => unit.name === templateValues.bunit)
                        ?.dataProviders.find(
                          (provider) =>
                            provider.name === templateValues.dataProvider
                        )?.rigs || []
                    ).map((rig) => (
                      <MenuItem key={rig.name} value={rig.name}>
                        {rig.name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="well"
                    select
                    name="well"
                    size="small"
                    label="Well"
                    variant="outlined"
                    value={templateValues.well}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.well === ""}
                    helperText={
                      formSubmitted && templateValues.well === ""
                        ? "Well is required"
                        : ""
                    }
                  >
                    {(
                      reportFilterData?.data.businessUnit
                        .find((unit) => unit.name === templateValues.bunit)
                        ?.dataProviders.find(
                          (provider) =>
                            provider.name === templateValues.dataProvider
                        )
                        ?.rigs.find((rig) => rig.name === templateValues.rig)
                        ?.wells || []
                    ).map((well) => (
                      <MenuItem key={well.name} value={well.name}>
                        {well.name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="wellbore"
                    select
                    name="wellbore"
                    size="small"
                    label="wellbore"
                    variant="outlined"
                    value={templateValues.wellbore}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.wellbore === ""}
                    helperText={
                      formSubmitted && templateValues.wellbore === ""
                        ? "Wellbore is required"
                        : ""
                    }
                  >
                    {reportFilterData?.data.businessUnit
                      .find((unit) => unit.name === templateValues.bunit)
                      ?.dataProviders.find(
                        (provider) =>
                          provider.name === templateValues.dataProvider
                      )
                      ?.rigs.find((rig) => rig.name === templateValues.rig)
                      ?.wells.filter(
                        (well) => well.name === templateValues.well
                      )
                      .map((well) => (
                        <MenuItem key={well.wellBore} value={well.wellBore}>
                          {well.wellBore}
                        </MenuItem>
                      ))}
                  </TextField>
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="log"
                    select
                    name="log"
                    size="small"
                    label="Log"
                    variant="outlined"
                    value={templateValues.log}
                    onChange={handleChange}
                    required
                    error={formSubmitted && templateValues.log === ""}
                    helperText={
                      formSubmitted && templateValues.log === ""
                        ? "Log is required"
                        : ""
                    }
                  >
                    {(
                      reportFilterData?.data.businessUnit
                        .find((unit) => unit.name === templateValues.bunit)
                        ?.dataProviders.find(
                          (provider) =>
                            provider.name === templateValues.dataProvider
                        )
                        ?.rigs.find((rig) => rig.name === templateValues.rig)
                        ?.wells.find(
                          (well) => well.name === templateValues.well
                        )?.logs || []
                    ).map((log) => (
                      <MenuItem key={log.name} value={log.name}>
                        {log.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="UidLog"
                    name="UidLog"
                    size="small"
                    label="Log Uid"
                    variant="outlined"
                    value={templateValues.UidLog}
                    onChange={handleChange}
                  />
                  <TextField
                    className="mr-2 mb-2"
                    id="logType"
                    select
                    label="Log Type"
                    defaultValue=""
                    variant="outlined"
                    size="small"
                    name="logType"
                    style={{ width: "203px" }}
                    value={templateValues.logType}
                    onChange={handleChange}
                  >
                    <MenuItem value="DEPTHSERIES">DEPTHSERIES</MenuItem>
                    <MenuItem value="TIMESERIES">TIMESERIES</MenuItem>
                  </TextField>
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="UidWell"
                    name="UidWell"
                    size="small"
                    label="Well Uid"
                    variant="outlined"
                    value={templateValues.UidWell}
                    onChange={handleChange}
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="UidWellbore"
                    name="UidWellbore"
                    size="small"
                    label="Wellbore Uid"
                    variant="outlined"
                    value={templateValues.UidWellbore}
                    onChange={handleChange}
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="windowLength"
                    name="windowLength"
                    size="small"
                    label="Window Length"
                    variant="outlined"
                    type="number"
                    defaultValue="0"
                    value={templateValues.windowLength}
                    onChange={handleChange}
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="slideBy"
                    name="slideBy"
                    size="small"
                    label="Window SlideBy"
                    variant="outlined"
                    type="number"
                    defaultValue="0"
                    value={templateValues.slideBy}
                    onChange={handleChange}
                  />

                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="nameWell"
                    name="nameWell"
                    size="small"
                    label="Name Well"
                    variant="outlined"
                    value={templateValues.well}
                    onChange={handleChange}
                  />
                  <TextField
                    className="mr-2 mb-2"
                    style={{ width: "203px" }}
                    id="nameWellbore"
                    name="nameWellbore"
                    size="small"
                    label="Name Wellbore Well"
                    variant="outlined"
                    value={templateValues.wellbore}
                    onChange={handleChange}
                  />
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between">
                    <p className="nameHeading" style={{ color: "#c7c7c7" }}>
                      Rules
                    </p>

                    <Tooltip title="Dashboard">
                      <Button
                        size={"small"}
                        startIcon={<AddIcon />}
                        onClick={handleShow}
                        style={{
                          // backgroundColor: "#c7c7c71f",
                          color: "#c7c7c7",
                          fontWeight: "bolder",
                          marginLeft: "8px",
                        }}
                      />
                    </Tooltip>

                    <Modal
                      show={show}
                      onHide={handleClose}
                      dialogClassName="modal-70w"
                      backdrop="static"
                      centered
                    >
                      <Modal.Header
                        closeButton
                        style={{ backgroundColor: "#161616" }}
                      >
                        <style>
                          {`
            .modal-header .close {
                color: white;
                
            }     
        `}
                        </style>
                        <Modal.Title style={{ color: "white" }}>
                          Create Rule Name
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ backgroundColor: "#242424" }}>
                        <TextField
                          className="mr-2 mb-2"
                          style={{ width: "203px" }}
                          id="ruleName"
                          name="ruleName"
                          size="small"
                          label="Rule Name"
                          variant="outlined"
                          onChange={handleModelChange}
                        />
                        <TextField
                          className="mr-2 mb-2"
                          style={{ width: "203px" }}
                          id="uom"
                          name="uom"
                          size="small"
                          label="UOM"
                          variant="outlined"
                          onChange={handleModelChange}
                        />
                        <TextField
                          className="mr-2 mb-2"
                          style={{ width: "203px" }}
                          id="datatype"
                          name="datatype"
                          size="small"
                          label="Data Type"
                          variant="outlined"
                          onChange={handleModelChange}
                        />
                      </Modal.Body>
                      <Modal.Footer style={{ backgroundColor: "#161616" }}>
                        <Button
                          variant="secondary"
                          onClick={handleClose}
                          style={{
                            ...buttonStyle,
                            color: "#c7c7c7",
                            marginRight: "10px",
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          onClick={handleSaveModel}
                          style={{
                            ...buttonStyle,
                            backgroundColor: "#161616",
                            color: "white",
                          }}
                        >
                          Save
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                  <div>
                    <FormControl
                      className="mr-2 mb-2"
                      size="small"
                      style={{ width: "203px", padding: "3px" }}
                    >
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        style={{ marginTop: "-8px", marginLeft: "25px" }}
                      >
                        Select Rules
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={ruleName}
                        onChange={handleChangeName}
                        input={<OutlinedInput label="Select Rules" />}
                        renderValue={(selected) => selected.join(", ")}
                        // MenuProps={MenuProps}
                      >
                        {names.map((name) => (
                          <MenuItem key={name} value={name}>
                            <Checkbox checked={ruleName.indexOf(name) > -1} />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {templateRuleValues.rules.map((rule, ruleIndex) => (
                    <Accordion>
                      <AccordionSummary
                        style={{ backgroundColor: "#161616", color: "#c7c7c7" }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography>{rule.name}</Typography>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          backgroundColor: "#242424",
                          color: "#c7c7c7",
                          border: "1px solid #797777",
                          borderTop: "none",
                        }}
                      >
                        <Typography>
                          <TextField
                            id="uom"
                            name="uom"
                            select
                            multiple
                            label="UOM"
                            defaultValue=""
                            variant="outlined"
                            size="small"
                            value={rule.uom} // Use rule.uom instead of uom
                            onChange={(event) =>
                              handleuomdpChange(event, ruleIndex)
                            } // Pass ruleIndex to handleuomdpChange
                            style={{ width: "203px" }}
                            className="mr-2 mb-2"
                          >
                            {uomList.map((uoms) => (
                              <MenuItem key={uoms} value={uoms}>
                                {uoms}
                              </MenuItem>
                            ))}
                          </TextField>
                          <TextField
                            id="datatype"
                            name="datatype"
                            select
                            multiple
                            label="Data Type"
                            defaultValue=""
                            variant="outlined"
                            size="small"
                            value={rule.datatype}
                            onChange={(event) =>
                              handleuomdpChange(event, ruleIndex)
                            } // Use the same handler for Data Type change
                            style={{ width: "203px" }}
                            className="mr-2 mb-2"
                          >
                            {dataTypeList.map((dataTypes) => (
                              <MenuItem value={dataTypes} key={dataTypes}>
                                {dataTypes}
                              </MenuItem>
                            ))}
                          </TextField>

                          {/* {templateRuleValues.rules.map((rule, ruleIndex) => ( */}
                          <div key={ruleIndex} className="mt-2">
                            {rule?.aspects?.map((aspect, aspectIndex) => (
                              <div key={aspectIndex}>
                                <Checkbox
                                  checked={
                                    aspect.status === "enable" ? true : false
                                  }
                                  name="status"
                                  // onChange={(e) => handleCheckboxChange(e, ruleIndex, aspectIndex, "status")} // Assuming handleCheckboxChange handles checkbox change events
                                  inputProps={{
                                    "aria-label": "controlled",
                                  }}
                                  onChange={(e) =>
                                    handleRuleChange(
                                      e,
                                      ruleIndex,
                                      aspectIndex,
                                      "status"
                                    )
                                  }
                                />
                                <TextField
                                  value={aspect.name}
                                  className="mr-2 mb-2"
                                  style={{ width: "203px" }}
                                  id={`aspect-name-${aspectIndex}`}
                                  name={`aspect-name-${aspectIndex}`}
                                  size="small"
                                  label="Name"
                                  variant="outlined"
                                  disabled
                                  InputProps={{
                                    style: { color: "rgb(0 0 0 / 75%)" }, // Change 'dark' to the specific dark color you want
                                  }}
                                  //   onChange={(e) => handleRuleChange(e, ruleIndex, aspectIndex, 'name')} // Assuming handleInputChange handles input change events
                                />
                                <TextField
                                  value={aspect.expectedValue}
                                  className="mr-2 mb-2"
                                  style={{ width: "203px" }}
                                  id={`aspect-expectedValue-${aspectIndex}`}
                                  name={`aspect-expectedValue-${aspectIndex}`}
                                  size="small"
                                  type="number"
                                  label="Expected Value"
                                  variant="outlined"
                                  // disabled={
                                  //   aspect.expectedValue === undefined
                                  // }
                                  onChange={(e) =>
                                    handleRuleChange(
                                      e,
                                      ruleIndex,
                                      aspectIndex,
                                      "expectedValue"
                                    )
                                  }
                                />
                                <TextField
                                  value={aspect.deltaValue}
                                  className="mr-2 mb-2"
                                  style={{ width: "203px" }}
                                  id={`aspect-deltaValue-${aspectIndex}`}
                                  name={`aspect-deltaValue-${aspectIndex}`}
                                  size="small"
                                  type="number"
                                  label="Delta Value"
                                  variant="outlined"
                                  // disabled={aspect.deltaValue === undefined}
                                  onChange={(e) =>
                                    handleRuleChange(
                                      e,
                                      ruleIndex,
                                      aspectIndex,
                                      "deltaValue"
                                    )
                                  }
                                />
                                <TextField
                                  value={aspect.weightage}
                                  className="mr-2 mb-2"
                                  style={{ width: "203px" }}
                                  id={`aspect-weightage-${aspectIndex}`}
                                  name={`aspect-weightage-${aspectIndex}`}
                                  size="small"
                                  type="number"
                                  label="Weightage"
                                  variant="outlined"
                                  // disabled={aspect.weightage === undefined}
                                  onChange={(e) =>
                                    handleRuleChange(
                                      e,
                                      ruleIndex,
                                      aspectIndex,
                                      "weightage"
                                    )
                                  }
                                />
                                <TextField
                                  value={aspect.ttThreshold}
                                  className="mr-2 mb-2"
                                  style={{ width: "203px" }}
                                  id={`aspect-ttThreshold-${aspectIndex}`}
                                  name={`aspect-ttThreshold-${aspectIndex}`}
                                  size="small"
                                  type="number"
                                  label="TT Threshold"
                                  // disabled={aspect.ttThreshold === undefined}
                                  variant="outlined"
                                  onChange={(e) =>
                                    handleRuleChange(
                                      e,
                                      ruleIndex,
                                      aspectIndex,
                                      "ttThreshold"
                                    )
                                  }
                                />
                              </div>
                            ))}
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: "-80px",
                    right: "0px",
                  }}
                >
                  <Tooltip title="Save">
                    <Button
                      startIcon={<SaveIcon />}
                      variant="contained"
                      component="span"
                      style={{
                        ...buttonStyle,
                        // backgroundColor: "#c7c7c7",
                        // color: "white",
                        marginBottom: "20px",
                      }}
                      onClick={handleSaveData}
                    >
                      Save
                    </Button>
                  </Tooltip>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template;
